import React, { useEffect, useState } from 'react'
import classes from './Contracts.module.scss'
import { useSelector } from 'react-redux'
import ContractInfo from '../../ContractInfo'
import ContractTable from '../../ContractTable'
import AddAgreements from '../../AddAgreements'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const Contracts = () => {

  const popup = useSelector(state=>state.ContractSlice.popup)
  const role = useSelector(state=>state.login.userInfo.permissions.contracts_manage)
  const show = useSelector(state=>state.ContractSlice.show)
  useEffect(()=>{
    if(popup && !role){
      toast.error('В доступі відмовлено!')
    }
  },[popup])

  return (
    <div className={classes.container}>
      {show && <div className={classes.box}>            
        <ContractInfo />
      </div>}
      <div className={classes.table}>
        <ContractTable/>
      </div>
      {popup && role && <AddAgreements/>}
    </div>
  )
}

export default Contracts